import styled, { css } from 'styled-components'

import { maxmedia, minmedia } from '../../styles/media-queries'
import {
  almostblack,
  inputgray,
  white,
  whitegray,
  bordergray,
  gold,
  lightergray,
  lightgray,
  black,
  red
} from '../../styles/colors'

export const Row = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  background: ${props => (props.currentUser ? whitegray : white)};
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;
  margin-bottom: 0.75rem;
  padding-top: 1rem;

  ${minmedia.medium`
    padding-top: 1.5rem;
  `} ${minmedia.large`
    padding: ${props => (props.noPadding ? '0' : '1.25rem 0')};
    margin-bottom: .5rem;
  `};
`

export const Item = styled.div`
  width: 100%;
  padding: 1rem;
  padding-top: 0;
  overflow: hidden;

  &:last-child {
    padding: 0; //reset
  }

  ${minmedia.medium`
    width: 50%;
    padding-bottom: 1.5rem;
  `} ${minmedia.large`
    width: calc(100%/4 - 80px);
    padding: 0; //reset

    &:first-child {
      padding-left: 1.5rem;
    }
    &:last-child {
      width: 80px;
    }
  `} ${props =>
      props.active &&
      css`
        ${Editor} {
          background: ${lightergray};
        }
        ${Dropdown} {
          display: block;

          ${maxmedia.large`
        display: flex;
      `};
        }
      `};
`

export const Sup = styled.div`
  text-transform: uppercase;
  font-size: 10px;
  color: ${inputgray};
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 0.5rem;

  ${minmedia.medium`
    font-size: 14px;
  `} ${minmedia.large`
    display: none;
  `};
`

export const Editor = styled.div`
  transition: background-color 0.5s;
  cursor: ${props => (props.manager ? 'normal' : 'pointer')};

  ${maxmedia.large`
    position: absolute;
    top: calc(50% - 1.25rem);
    right: .5rem;
    padding: .5rem 1rem;
  `} ${maxmedia.medium`
    top: 0;
    right: 0;
  `} ${minmedia.large`
    padding: 1rem;
    border-left: 1px solid ${bordergray};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    &:hover {
      background: ${props => (props.manager ? 'none' : lightgray)};
    }
  `};
`

export const DotsContainer = styled.div`
  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: ${inputgray};
  }

  &:hover {
    svg {
      fill: ${gold};
    }
  }
`

export const Dropdown = styled.div`
  display: none;

  ${maxmedia.large`
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 10;
    position: absolute;
    background: ${lightergray};
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  `} ${minmedia.large`
    z-index: 2;
    position: absolute;
    transform: translateY(100%);
    bottom: 0;
    right: 0;
    background: ${white};
    border-radius: .25rem;
    border-top-right-radius: 0;
    border: 1px solid ${bordergray};
    box-shadow: 0 2px 4px ${bordergray};
  `};
`

export const DropdownItem = styled.div`
  cursor: pointer;

  a {
    color: ${almostblack};
    text-decoration: none;
  }

  ${maxmedia.large`
    transition: all 0.5s;
    display: inline-block;
    background: ${white};
    color: ${black};
    border: 1px solid ${lightgray};
    border-radius: 0.25rem;
    font-size: 16px;
    font-weight: 300;
    padding: 0.75rem 1.5rem;
    cursor: pointer;

    &:hover {
      background: ${almostblack};
      color: ${white};

      a {
        color: ${white};
      }
    }

    &:first-child {
      margin-left: .75rem;
      order: 2;
    }
  `} ${minmedia.large`
    padding: .5rem 1.5rem;

    &:hover {
      background: ${lightergray};
    }
  `};
`

export const CloseButton = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;

  ${minmedia.medium`
    top: auto;
  `} ${minmedia.large`
    display: none;
  `} &:hover {
    fill: ${red};
  }

  svg {
    width: 0.75rem;
    height: 0.75rem;
    fill: ${black};
  }
`



// WEBPACK FOOTER //
// ./src/components/TableRow/styles.js